import { useEffect, useRef } from "react";
import { useTableStore } from "../../state/TableStore";
import { AlertColor } from "../../customEnums/AlertColor";
import { useToastAlert } from "./useToastAlert";

type NoSearchResultsOptions = {
    onClose?: () => void;
    title?: string;
    message?: string;
};

export const useNoSearchResultsToast = (options: NoSearchResultsOptions = {}) => {
    const {
        onClose,
        title = "No Results",
        message = "Search criteria does not return any results. Please update your search criteria and try again.",
    } = options;
    const displayNoSearchResults = useTableStore((state) => state.displayNoSearchResults);
    const setDisplayNoSearchResults = useTableStore((state) => state.setDisplayNoSearchResults);
    const { enqueueAlert, dismissAlert } = useToastAlert();
    const noResultsAlertIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (displayNoSearchResults && !noResultsAlertIdRef.current) {
            noResultsAlertIdRef.current = enqueueAlert({
                title,
                message,
                severity: AlertColor.INFO,
                onClose: () => {
                    setDisplayNoSearchResults(false);
                    onClose?.();
                },
            });
        } else if (!displayNoSearchResults && noResultsAlertIdRef.current) {
            dismissAlert(noResultsAlertIdRef.current);
            noResultsAlertIdRef.current = null;
        }
    }, [displayNoSearchResults, enqueueAlert, dismissAlert, setDisplayNoSearchResults, title, message, onClose]);
};